import { render, staticRenderFns } from "./PendingDocsFilter.vue?vue&type=template&id=45fa6faa"
import script from "./PendingDocsFilter.vue?vue&type=script&lang=js"
export * from "./PendingDocsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45fa6faa')) {
      api.createRecord('45fa6faa', component.options)
    } else {
      api.reload('45fa6faa', component.options)
    }
    module.hot.accept("./PendingDocsFilter.vue?vue&type=template&id=45fa6faa", function () {
      api.rerender('45fa6faa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/components/PendingDocsFilter.vue"
export default component.exports